import styles from './SocialIcons.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SOCIAL_ICONS } from '../../constants'

const SocialIcons = () =>{
    const icons = SOCIAL_ICONS.map((item, key) => 
            <FontAwesomeIcon className={styles.icon} icon={item.icon} key={key} onClick={()=>{window.open(item.link, '_blank')}}/>
        );
    return(
        <div className={styles.iconsWrapper}>
            {icons}
        </div>
    )
}

export default SocialIcons
